import React from "react";
import PropTypes from "prop-types";
import connectToMedia from "../../Media/connectToMedia";
import Playhead from "./Playhead";
import S from "../../../styles/components";

const mapStateToProps = (state) => ({ ...state.media });

export class Timeline extends React.Component {
  static propTypes = {
    duration: PropTypes.number,
    currentTime: PropTypes.number,
    children: PropTypes.node,
    contextMediaElement: PropTypes.instanceOf(Element),
  };

  static defaultProps = {
    color: "black",
  };

  seek = (e) => {
    const { duration, onSeek, isChatTextMedia, messagesDuration } = this.props;
    const rect = e.target.getBoundingClientRect();
    const totalDuration = isChatTextMedia ? messagesDuration : duration;
    onSeek({
      s: ((e.clientX - (rect.x || rect.left)) / rect.width) * totalDuration,
    });
  };

  render() {
    const {
      children,
      currentTime = 0,
      duration = 0,
      isSentimentAnalyzerOn,
      isChatTextMedia,
      messagesDuration,
    } = this.props;
    const totalDuration = isChatTextMedia ? messagesDuration : duration;
    const progress = (currentTime / totalDuration) * 100 || 0;

    return (
      <S.Timeline>
        <S.TimelineBody>
          <Playhead
            isChatTextMedia={isChatTextMedia}
            onSeek={this.seek}
            progress={progress}
            isSentimentAnalyzerOn={isSentimentAnalyzerOn}
          />
          {children}
        </S.TimelineBody>
      </S.Timeline>
    );
  }
}

export default connectToMedia(mapStateToProps)(Timeline);
